import { gql } from "@apollo/client";

export const LOAD_QUERY = gql`
  query GetLoad($id: ID!) {
    load(id: $id) {
      id
      load_number
      delivery_date
      weight
      van_type
      type
      fee_type
      declared_value
      primary_fees
      load_commodity
      pick_up_commodity
      pick_up_date
      delivery_commodity
      delivery_appt
      pick_up_appt
      customer {
        id
        name
      }
      shipper {
        id
        name
      }
      consignee {
        id
        name
      }
    }
  }
`;
